// extracted by mini-css-extract-plugin
export default {"facetMenu":"Ww-z","fixed":"Xw-z","nonLayerdFacets":"Yw-z","productCount":"Zw-z","facetBack":"_w-z","arrow":"ax-z","facetClose":"bx-z"};